import React, { Component } from "react";
import { Table, Card, Row, Col, Button, Image } from "react-bootstrap";
import AddSupportUsers from "./AddSupportUsers";
import "./style.css";
import DeleteSupportUsers from "./DeleteSupportUsers";
import EditSupportUsers from "./EditSupportUsers";
import "./SupportUsers.css";
import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");

class SupportUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ShowAddModel: false,
      showEdit: false,
      ItemList: "",
      showDelete: false,
      searchShow: false,
      searchSupportUsers: "",
      perPage: 10,
      page: 0,
      Spage: 0,
      perPageS: 10,
      filterValue: "All",
      FilterTable: false,
    };
    this.closeDeleteModel = this.closeDeleteModel.bind(this);
    this.editmodel = this.editmodel.bind(this);
    this.closeEdtModel = this.closeEdtModel.bind(this);
    this.showDeleteModel = this.showDeleteModel.bind(this);
  }
  componentDidMount() {
    this.props.supportUsersViewList();
  }
  editmodel = (item) => {
    this.setState({
      ItemList: item,
      showEdit: true,
    });
  };

  closeEdtModel = () => {
    this.setState({
      showEdit: false,
    });
  };

  showDeleteModel = (item) => {
    this.setState({
      showDelete: true,
      DeleteItems: item,
    });
  };
  closeDeleteModel = () => {
    this.setState({
      showDelete: false,
    });
  };
  handleShowAdd = () => {
    this.setState({
      ShowAddModel: true,
      searchShow: false,
    });
  };
  handleCloseView = () => {
    this.setState({ ShowAddModel: false });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;

    this.props.supportUsersSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  handlePageSearchClick = (e) => {
    const selectedSearchPage = e.selected;
    this.setState({ Spage: selectedSearchPage });

    this.props.supportUsersSearch({
      searchSupportUsers: this.state.searchSupportUsers,
      Spage: selectedSearchPage + 1,
    });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };

  SearchOnChange = (event) => {
    let supportUsers = event.target.value;

    this.setState({
      searchShow: true,
      searchSupportUsers: supportUsers,
      FilterTable: false,
      filterValue: "All",
    });
    this.props.supportUsersSearch({
      searchSupportUsers: supportUsers,
      Spage: this.state.Spage + 1,
    });
  };

  render() {
    let p = this.state.page + 1;
    const count =
      this.props.supportUsersDtlsCount && this.props.supportUsersDtlsCount;
    let supportUsersPageCount = Math.ceil(count / this.state.perPage);

    let p2 = this.state.Spage + 1;

    const SearchCount =
      this.props.supportUsersSearchCount && this.props.supportUsersSearchCount;
    const SearchPageCount = Math.ceil(SearchCount / this.state.perPageS);
    return (
      <div>
        <div>
          <div>
            <div className="supportUsers_Div">
              <Card>
                <Card.Header>
                  <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
                    <Col
                      xs={12}
                      sm={12}
                      md={3}
                      lg={3}
                    >
                      <h3>Support Users</h3>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3}>
                        <div className="userInput">
                          <i className="fa fa-search fa-lg userIcon"></i>
                          <input
                            type="text"
                            placeholder="Search by First Name"
                            onChange={this.SearchOnChange}
                          />
                        </div>
                    </Col>

                    <Col xs={12} sm={12} md={3} lg={3}>
                      <div className="totalRecord">
                        <i
                          className="cui-note icons"
                          style={{ fontSize: "15px" }}
                        ></i>
                        <span
                          style={{
                            padding: "5px",
                            fontWeight: 600,
                            fontSize: "18px",
                            opacity: ".7",
                          }}
                        >
                          {count === undefined && SearchCount === undefined ? (
                            0
                          ) : (
                            <span>
                              {!this.state.searchShow &&
                                !this.state.FilterTable &&
                                count}
                              {this.state.searchShow &&
                                !this.state.FilterTable &&
                                SearchCount}
                            </span>
                          )}
                        </span>
                        <span style={{ opacity: ".7" }}>Results</span>
                      </div>
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body>
                  <Button
                    style={{ marginBottom: "15px" }}
                    onClick={() => this.handleShowAdd()}
                  >
                    <i className="fa fa-plus fa-md"></i>
                    <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                      ADD
                    </span>
                  </Button>
                  <AddSupportUsers
                    ShowAddModel={this.state.ShowAddModel}
                    handleClose={this.handleCloseView}
                    addSupportUsers={this.props.addSupportUsers}
                    resetPage={this.resetPage}
                  />
                  {!this.state.searchShow && !this.state.FilterTable && (
                    // <div className="SupportUsersMainTable">
                    <Table responsive striped className="cmnMainTable" bordered>
                      <thead>
                        <tr className="cmnMainTableHd">
                          <th>SL NO</th>
                          <th>FIRST NAME</th>
                          <th>LAST NAME</th>
                          <th>DESIGNATION</th>
                          <th>EMAIL ID</th>
                          <th>MOBILE NUMBER</th>
                          <th>STATUS</th>
                          <th>CREATED DATE</th>
                          <th>ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.supportUsersList &&
                          this.props.supportUsersList.map((item, i) => (
                            <tr key={i}>
                              <td>{10 * (p - 1) + i + 1}</td>
                              {}
                              <td className="cmn_Cap">
                                {item.fName !== null && item.fName}
                              </td>
                              <td className="cmn_Cap">
                                {item.lName !== null && item.lName}
                              </td>
                              <td className="cmn_Cap">
                                {item.dsgntn !== null && item.dsgntn}
                              </td>
                              <td className="">
                                {item.email !== null && item.email}
                              </td>
                              <td className="cmn_Cap">
                                {item.mob !== null && item.mob}
                              </td>
                              <td className="cmn_Cap">
                                {item.status !== null && item.status}
                              </td>
                              <td className="cmn_Cap">
                                {dateFormat(item.createdAt, "mediumDate")}
                              </td>
                              <td className="cmnViewIcon">
                                {" "}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <i
                                    className="fa fa-edit fa-lg "
                                    onClick={() => this.editmodel(item)}
                                  ></i>
                                  <EditSupportUsers
                                    editShow={this.state.showEdit}
                                    closemodel={this.closeEdtModel}
                                    ItemList={this.state.ItemList}
                                    editSupportUsers={
                                      this.props.editSupportUsers
                                    }
                                    resetPage={this.resetPage}
                                  />
                                  <i
                                    className="fa fa-trash fa-lg "
                                    style={{
                                      paddingLeft: 10,
                                    }}
                                    onClick={() => this.showDeleteModel(item)}
                                  ></i>
                                  <DeleteSupportUsers
                                    showDelete={this.state.showDelete}
                                    DeleteItems={this.state.DeleteItems}
                                    closeDeleteModel={this.closeDeleteModel}
                                    deleteSupportUsers={
                                      this.props.deleteSupportUsers
                                    }
                                    resetPage={this.resetPage}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                    // </div>
                  )}
                  {/* ------------------------search---------------------- */}
                  {this.state.searchShow && !this.state.FilterTable && (
                    // <div className="SupportUsersMainTable">
                    <Table responsive striped className="cmnMainTable" bordered>
                      <thead>
                        <tr className="cmnMainTableHd">
                          <th>SL NO</th>
                          <th>FIRST NAME</th>
                          <th>LAST NAME</th>
                          <th>DESIGNATION</th>
                          <th>EMAIL ID</th>
                          <th>MOBILE NUMBER</th>
                          <th>STATUS</th>
                          <th>CREATED DATE</th>
                          <th>ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.supportUsersSearchList &&
                          this.props.supportUsersSearchList.map((item, i) => (
                            <tr key={i}>
                              <td>{10 * (p2 - 1) + i + 1}</td>
                              {}
                              <td className="cmn_Cap">
                                {item.fName !== null && item.fName}
                              </td>
                              <td className="cmn_Cap">
                                {item.lName !== null && item.lName}
                              </td>
                              <td className="cmn_Cap">
                                {item.dsgntn !== null && item.dsgntn}
                              </td>
                              <td className="">
                                {item.email !== null && item.email}
                              </td>
                              <td className="cmn_Cap">
                                {item.mob !== null && item.mob}
                              </td>
                              <td className="cmn_Cap">
                                {item.status !== null && item.status}
                              </td>
                              <td className="cmn_Cap">
                                {dateFormat(item.createdAt, "mediumDate")}
                              </td>
                              <td className="cmnViewIcon">
                                {" "}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <i
                                    className="fa fa-edit fa-lg"
                                    onClick={() => this.editmodel(item)}
                                  ></i>
                                  <EditSupportUsers
                                    editShow={this.state.showEdit}
                                    closemodel={this.closeEdtModel}
                                    ItemList={this.state.ItemList}
                                    editSupportUsers={
                                      this.props.editSupportUsers
                                    }
                                    resetPage={this.resetPage}
                                  />
                                  <i
                                    className="fa fa-trash fa-lg"
                                    style={{
                                      paddingLeft: 10,
                                    }}
                                    onClick={() => this.showDeleteModel(item)}
                                  ></i>
                                  <DeleteSupportUsers
                                    showDelete={this.state.showDelete}
                                    DeleteItems={this.state.DeleteItems}
                                    closeDeleteModel={this.closeDeleteModel}
                                    deleteSupportUsers={
                                      this.props.deleteSupportUsers
                                    }
                                    resetPage={this.resetPage}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                    // </div>
                  )}

                  {!this.state.searchShow &&
                    (this.props.supportUsersList === undefined ||
                      (this.props.supportUsersList &&
                        this.props.supportUsersList.length === 0)) && (
                      <div>
                        <div className="noDataImgDiv">
                          <Image
                            className="noDataImg"
                            src={require("../../assets/img/nodata4.png")}
                          />
                        </div>
                        <div className="noDataTextDiv">
                          No Support Users Found
                        </div>
                      </div>
                    )}

                  {this.state.searchShow &&
                    (this.props.supportUsersSearchList === undefined ||
                      (this.props.supportUsersSearchList &&
                        this.props.supportUsersSearchList.length === 0)) && (
                      <div>
                        <div className="noDataImgDiv">
                          <Image
                            className="noDataImg"
                            src={require("../../assets/img/nodata4.png")}
                          />
                        </div>
                        <div className="noDataTextDiv">
                          No Support Users Found
                        </div>
                      </div>
                    )}
                </Card.Body>
                {!this.state.searchShow &&
                supportUsersPageCount &&
                supportUsersPageCount > 1 ? (
                  <div className="paginationDiv">
                    <ReactPaginate
                      forcePage={this.state.page}
                      previousLabel={"Prev"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={supportUsersPageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={this.handlePageClick}
                      containerClassName={"pagination flex-wrap"}
                      subContainerClassName={"pages pagination"}
                      activeClassName={"active"}
                    />
                  </div>
                ) : null}

                {this.state.searchShow &&
                SearchPageCount &&
                SearchPageCount > 1 ? (
                  <div className="paginationDiv">
                    <ReactPaginate
                      forcePage={this.state.Spage}
                      previousLabel={"Prev"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={SearchPageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={this.handlePageSearchClick}
                      containerClassName={"pagination flex-wrap"}
                      subContainerClassName={"pages pagination"}
                      activeClassName={"active"}
                    />
                  </div>
                ) : null}
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SupportUsers;
